/** The studio footer piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { StudioFooterEvents } from './contract';
import { StudioFooterView } from './StudioFooterView';
import { useStudioFooter } from './useStudioFooter';

export function StudioFooter(props: PieceInput<StudioFooterEvents>) {
  return <StudioFooterView {...useStudioFooter(props)} />;
}
